// extracted by mini-css-extract-plugin
export default {"coaching_section":"coaching_coaching_section__xm2oY","coachImg":"coaching_coachImg__tP4x2"};